<template>
  <v-card>
    <alert-error :error="error" />
    <v-card-text>
      <helper :relations="relations || []" @show="show" />
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'HelperPage',

  components: {
    AlertError: () => import('@/modules/_global/_components/AlertError'),
    Helper: () => import('@/modules/persons/components/Tabs/helper/Helper.vue')
  },

  props: {
    personId: {
      type: Number,
      required: true
    }
  },

  data: () => ({
    relations: [],
    error: null,
    unwatch: null
  }),

  created() {
    this.unwatch = this.$store.watch(
      state => state.localization.lang,
      () => {
        const lang = this.$store.state.localization.lang;

        if (lang) {
          this.getRelationsHelp();
        }
      }
    );

    this.getRelationsHelp();
  },

  destroyed() {
    this.unwatch();
  },

  methods: {
    getRelationsHelp() {
      this.$store
        .dispatch('relation/retrieveRelationsHelp', this.personId)
        .then(({ data }) => {
          this.relations = data;
        })
        .catch(error => {
          this.error = error.response;
        });
    },

    show(personId) {
      this.$router.push({
        name: 'persons.show',
        params: { id: personId }
      });
    }
  }
};
</script>
